import { render, staticRenderFns } from "./SettingsDetail.vue?vue&type=template&id=c82f016a&scoped=true&"
import script from "./SettingsDetail.vue?vue&type=script&lang=js&"
export * from "./SettingsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82f016a",
  null
  
)

export default component.exports